let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("eViR4")]).then(() => parcelRequire('6ItgB'));